export default __webpack_public_path__ + "static/media/3.905f3070.png";